<template>
    <div class="white_bg">
        <div class="inner paddingH12">

            <div>
                <div class="formRow flexLayout searchFormRow">
                    <div class="columnName" style="width: 80px;">用户账号：</div>
                    <div class="columnValue bgGrey888 flexItem" style="background-image: url(icon/search_icon.png);">
                        <input type="text" class="inputbox block" placeholder="请输入用户账号（邀请码）查询"/>
                    </div>
                </div>
                <div class="formRow flexLayout searchFormRow" style="margin-top: 6px;">
                    <div class="columnName" style="width: 80px;">用户姓名：</div>
                    <div class="columnValue bgGrey888 flexItem" style="background-image: url(icon/search_icon.png);">
                        <input type="text" class="inputbox block" placeholder="请输入用户姓名查询"/>
                    </div>
                </div>
            </div>

            <div>
                <div class="marginT24 alignC">
                    <img src="" alt="" width="170" height="148px;"/>
                </div>
                <div class="marginT12 alignC">您还未进行园所会员认证无法分配老师账号哦，快去认证吧！</div>
                <div class="" style="margin-top: 130px;">
                    <button class="authenticationButton font14r">园所会员认证</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import generalCmpPart from '@/components/part/generalCmpPart';

// config
import appConfig    from '@/appConfig';

// util and api
import arrayHelper  from '@/util/arrayHelper';
import numberHelper from "@/util/numberHelper";
import appHelper    from "@/util/appHelper";

const config = {
    apiConfig : {
        list : {
            url : '',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            totalPath : 'data.total',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '园长“苦恼”，幼儿园之间到底在竞争什么',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: "kindergarenVipAccountManage",
    extends : generalCmpPart,
    components : {  },
    data () {
        return {
            apiConfig : config.apiConfig
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                  id : i,
                  title : arrayHelper.getRandomItem(config.demoTitleList),
                  coverImg : appHelper.getRandomCoverImage(),
                  createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                  userHead : appHelper.getRandomUserHead(),
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bgGrey888 {
    background: #888888;
}
.formRow {
    line-height: 27px;
    .columnName {
        color: #5B616C;
    }
    .columnValue {

        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.searchFormRow {
    .columnValue {
        padding-right: 34px;
        background-color: #F2F3F7;
        background-repeat: no-repeat;
        background-position: top right;
    }
    .inputbox {
        width: 180px;
    }
}
.authenticationButton {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    background-color: rgba(233, 157, 66, 1);
    color: white;
    border: 0 none;
}
</style>
